import { useState, useEffect } from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "next-themes";

export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mounted, setMounted] = useState(false);
  const { theme, setTheme } = useTheme();

  useEffect(() => {
    // Hydration mismatch 방지를 위한 의도적인 패턴
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 px-4 py-3 flex justify-between items-center ${isScrolled
          ? "bg-background/90 backdrop-blur-sm rough-shadow"
          : "bg-background/90 backdrop-blur-sm"
        }`}
    >
      {/* Logo */}
      <button
        onClick={scrollToTop}
        className="font-display text-primary text-2xl tracking-wider hover-lift cursor-pointer"
      >
        JC MINISTRY
      </button>

      {/* Theme Toggle */}
      <button
        onClick={toggleTheme}
        className="p-2 rounded-full hover:bg-primary/10 transition-colors hover-lift"
      >
        {mounted ? (
          theme === "dark" ? (
            <Sun className="text-primary w-5 h-5" />
          ) : (
            <Moon className="text-primary w-5 h-5" />
          )
        ) : (
          <div className="w-5 h-5" />
        )}
      </button>
    </nav>
  );
}